module.exports = __webpack_public_path__ + "img/winwheel-bg-image.86682139.png";